import * as React from "react";
import * as lodash from "lodash";
import HumanJson from "../human";

const { Component } = React;

import { Input, Row, Col, Label, Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Alert, Container } from "reactstrap";
import { Router, Route, Link, useNavigate } from "react-router-dom";
import * as AccountStore from "../account/AccountStore";
import axios from "../general/HttpClient";
import Avatar from "react-avatar";

interface ProfileState {
    currentUser: any;
    showResendConfirmationModal: boolean;
    userUpdated: boolean;
    user: any;
    showUserUpdatedMessage: boolean;
    sharedKey: string;
    authenticatorUri: string;
    humanJson: any;
}

const Profile = () => {
    const [currentUser, setCurrentUser] = React.useState({} as AccountStore.Account);
    const [showResendConfirmationModal, setShowResendConfirmationModal] = React.useState(false);
    const [userUpdated, setUserUpdated] = React.useState(true);
    const [user, setUser] = React.useState({ twoFactorEnabled: false } as AccountStore.Account);
    const [showUserUpdatedMessage, setShowUserUpdatedMessage] = React.useState(false);
    const [sharedKey, setSharedKey] = React.useState("");
    const [authenticatorUri, setAuthenticatorUri] = React.useState("");
    const [humanJson, setHumanJson] = React.useState("");

    const [loginLink, setLoginLink] = React.useState("");

    const navigate = useNavigate();

    React.useEffect(() => {
        GetCurrentUser();
        axios
            .get("/Account/LoginLink", {
                params: {
                    link: window.location.origin + "/" + "profile",
                },
            })
            .then((response) => {
                setLoginLink(response.data);
            });
    }, []);

    React.useEffect(() => {
        if (!userUpdated) {
            debouncedUpdate(user);
        }
    }, [userUpdated, user]);

    const debouncedUpdate = React.useRef(
        lodash.debounce((user) => {
            return AccountStore.UpdateUser(user).then((response) => {
                GetCurrentUser();
                setShowUserUpdatedMessage(true);
                setUserUpdated(true);

                setTimeout(() => {
                    setShowUserUpdatedMessage(false);
                }, 1500);
                return response;
            });
        }, 1500)
    ).current;

    const GetCurrentUser = () => {
        AccountStore.GetCurrentLoggedInUser(true).then((user) => {
            setCurrentUser(user);
            setUser(lodash.clone(user));
            setHumanJson(HumanJson.format(user.data || {}));
        });
    };

    const handleProfileDataChange = (key) => (e) => {
        let value = e.target.value;

        let userClone = lodash.clone(user);

        lodash.set(userClone, key, value);
        setUserUpdated(false);
        setUser(userClone);
    };

    const resendEmailConfirmation = () => {
        axios
            .get("/api/AccountActions/ResendAccountConfirmation", {
                params: {
                    email: currentUser.email,
                },
            })
            .then((response) => {
                setShowResendConfirmationModal(true);
            });
    };

    const toggleResendConfirmation = () => {
        setShowResendConfirmationModal(!showResendConfirmationModal);
    };

    const updateUser = () => {
        AccountStore.UpdateUser(user).then((response) => {
            navigate("/");
        });
    };

    const copyLink = (url) => () => {
        // @ts-ignore
        navigator.permissions.query({ name: "clipboard-write" }).then((result) => {
            if (result.state == "granted" || result.state == "prompt") {
                navigator.clipboard.writeText(url).then(
                    function () {
                        /* clipboard successfully set */
                    },
                    function (e) {
                        console.log(e);
                        /* clipboard write failed */
                    }
                );
            }
        });
    };

    return (
        <div style={{ marginTop: "47px" }} className="px-4">
            <h1>
                <Avatar round={true} size={"70px"} name={currentUser.fullName} src={currentUser.photo} className="me-3" />
                {currentUser.firstName} {currentUser.lastName}
            </h1>
            <h2>{currentUser.email}</h2>
            <p>{currentUser.userName}</p>

            <a href="#" onClick={copyLink(loginLink)}>
                Login Link
            </a>

            <div className="m-2">
                <Link to="/profile">Profile</Link>
                <Link to="/profile/data" className="ms-2">
                    Data
                </Link>
                <Link to="/profile/mfa" className="ms-2">
                    MFA
                </Link>
                <Link to="/profile/security" className="ms-2">
                    Security
                </Link>
            </div>

            {currentUser.email && !currentUser.emailConfirmed && (
                <Alert color="warning">
                    Your email address has not been confirmed. Click here to{" "}
                    <a href="#" className="alert-link" onClick={resendEmailConfirmation}>
                        resend email
                    </a>{" "}
                    confirmation.
                </Alert>
            )}
            <Row>
                <Col md={12} lg={4}>
                    <FormGroup>
                        <Label for="firstName">First Name</Label>
                        <Input id="firstName" type="text" disabled value={user.firstName || ""} onChange={handleProfileDataChange("firstName")} invalid={!user.firstName}></Input>
                    </FormGroup>

                    <FormGroup>
                        <Label for="lastName">Last Name</Label>
                        <Input id="lastName" type="text" disabled value={user.lastName || ""} onChange={handleProfileDataChange("lastName")} invalid={!user.lastName}></Input>
                    </FormGroup>

                    <FormGroup>
                        <Label for="cellNumber">Cell Number</Label>
                        <Input id="cellNumber" type="text" disabled value={user.phoneNumber || ""} onChange={handleProfileDataChange("phoneNumber")} invalid={!user.phoneNumber}></Input>
                    </FormGroup>

                    <FormGroup>
                        <Label for="email">Email</Label>
                        <Input id="email" type="text" disabled value={user.email || ""} onChange={handleProfileDataChange("email")} invalid={!user.email}></Input>
                    </FormGroup>
                </Col>
            </Row>

            <div className="my-2">
                {/* <Button color="primary" onClick={updateUser}>
                    Update
                </Button> */}
            </div>

            <Alert isOpen={showUserUpdatedMessage} color="success" className="p-2">
                Profile updated successfully
            </Alert>

            <Modal isOpen={showResendConfirmationModal} toggle={toggleResendConfirmation} centered={true}>
                <ModalBody>Email confirmation request resent. Please check your inbox and junk folders.</ModalBody>
            </Modal>
        </div>
    );
};

export default Profile;
